module.exports = __webpack_public_path__ + "img/activate_white.e42094e7.svg";